import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/nodes/CreateNodeContent/CreateNodeContent.tsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useDragLayer, useDrop } from 'react-dnd';
import { DndOverNodeContent } from "../../../Common/UI/DndOverNodeContent";
import { DndType } from "../../../DragNDrop/dndType";
import { FormNodeContent } from "../FormNodeContent";
import { CreateNodeFieldLayout } from "./CreateNodeContent.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CreateNodeContent = function CreateNodeContent(_ref) {
  var node = _ref.node,
      path = _ref.path,
      onCancelCreating = _ref.onCancelCreating,
      onSubmitCreating = _ref.onSubmitCreating,
      onDroppedToGroup = _ref.onDroppedToGroup,
      canDropToGroup = _ref.canDropToGroup;
  var deepness = path.length - 1;

  var _useDragLayer = useDragLayer(function (monitor) {
    return {
      someoneDragging: monitor.isDragging(),
      dragItem: monitor.getItem()
    };
  }),
      someoneDragging = _useDragLayer.someoneDragging,
      dragItem = _useDragLayer.dragItem;

  var _useDrop = useDrop({
    accept: [DndType.FROM_OWN_CLASSIFIER, DndType.FROM_DEPENDENCIES],
    drop: function drop(_ref2) {
      var type = _ref2.type;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onDroppedToGroup({
        target: null,
        from: type
      });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    canDrop: function canDrop(_ref3) {
      var type = _ref3.type;
      return canDropToGroup({
        from: type,
        target: null
      });
    },
    collect: function collect(m) {
      return {
        isOver: m.isOver(),
        canDrop: m.canDrop()
      };
    }
  }),
      _useDrop2 = _slicedToArray(_useDrop, 2),
      _useDrop2$ = _useDrop2[0],
      isOver = _useDrop2$.isOver,
      canDrop = _useDrop2$.canDrop,
      dropRef = _useDrop2[1];

  return node.createType === 'Field' ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DndOverNodeContent, {
      canDrop: canDrop,
      isDragging: someoneDragging && (dragItem === null || dragItem === void 0 ? void 0 : dragItem.type) !== 'ORDERING',
      someoneDragging: someoneDragging
    }), /*#__PURE__*/_jsx(CreateNodeFieldLayout, {
      isOver: isOver && canDrop,
      ref: dropRef
    })]
  }) : /*#__PURE__*/_jsx(FormNodeContent, {
    deepness: deepness,
    initialValue: "",
    onSubmit: function onSubmit(v) {
      return onSubmitCreating(v, node);
    },
    onCancel: onCancelCreating
  });
};